/* eslint-disable import-extensions/file-extension-required */
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { UseQueryInteropSupportedHookOptions } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop';

import type {
	useDraftsDataHomeDraftsQuery$data,
	useDraftsDataHomeDraftsQuery$variables,
} from './__generated__/useDraftsDataHomeDraftsQuery.graphql';

const PAGE_SIZE = 24;

export const DRAFTS_QUERY_OPTIONS: UseQueryInteropSupportedHookOptions<
	useDraftsDataHomeDraftsQuery$data,
	useDraftsDataHomeDraftsQuery$variables
> = {
	variables: {
		cqlcontext: `{"contentStatuses":["draft"]}`,
		first: PAGE_SIZE,
	},
};
